import { useIntl } from 'react-intl';
import { EffortContactItem } from 'library/types';
import { gray } from 'providers/theme/themePrimitives';
import { renderAutoCompleteLocaleText, selectByIds, toIds } from 'utils';
import { Autocomplete, svgIconClasses, TextField, useTheme } from '@mui/material';

type AutocompleteMultiByIdProps = {
  options: EffortContactItem[];
  valueIds: number[];
  onChangeIds: (ids: number[]) => void;
  errorText?: string;
};

const AutocompleteMultiById = ({ options, valueIds, onChangeIds, errorText }: AutocompleteMultiByIdProps) => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <Autocomplete
      size="small"
      multiple
      options={options}
      value={selectByIds(options, valueIds)}
      filterSelectedOptions
      disableCloseOnSelect
      {...renderAutoCompleteLocaleText(intl)}
      isOptionEqualToValue={(opt, val) => opt.id === val.id}
      getOptionLabel={(opt) => opt.title}
      onChange={(_, newValue) => onChangeIds(toIds(newValue))}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={{
            '& .MuiButtonBase-root': {
              border: 'none',
              width: 'fit-content',
              height: '2.25rem',
              padding: '0.25rem',
              [`& .${svgIconClasses.root}`]: { fontSize: '1rem' },
              '&:hover': {
                backgroundColor: theme.palette.mode === 'light' ? gray[100] : gray[800],
              },
            },
            '& .MuiInputBase-root': {
              height: 'auto',
            },
          }}
          error={!!errorText}
          helperText={errorText}
        />
      )}
    />
  );
};

export default AutocompleteMultiById;
